"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OracleThumbs = void 0;
var react_1 = __importDefault(require("react"));
var hooks_1 = require("services/static-text/hooks");
var OracleIconButton_1 = __importDefault(require("./OracleIconButton"));
var OracleThumbs = function (_a) {
    var value = _a.value, onThumbsUp = _a.onThumbsUp, onThumbsDown = _a.onThumbsDown, _b = _a.className, className = _b === void 0 ? '' : _b;
    var translate = (0, hooks_1.useTranslation)('oracleCommons');
    var thumbsUpLabel = translate('thumbsUp');
    var thumbsDownLabel = translate('thumbsDown');
    var baseClass = 'oracle-thumbs';
    var combinedClassName = "".concat(baseClass, " ").concat(className).trim();
    var thumbsUpActiveClass = value === 'up' ? "".concat(baseClass, "__button--active") : '';
    var thumbsDownActiveClass = value === 'down' ? "".concat(baseClass, "__button--active") : '';
    return (react_1.default.createElement("div", { className: combinedClassName },
        react_1.default.createElement(OracleIconButton_1.default, { icon: value === 'up' ? 'thumbs-up-filled' : 'thumbs-up', "aria-label": thumbsUpLabel, onClick: onThumbsUp, className: "".concat(baseClass, "__button ").concat(thumbsUpActiveClass).trim() }),
        react_1.default.createElement(OracleIconButton_1.default, { icon: value === 'down' ? 'thumbs-down-filled' : 'thumbs-down', "aria-label": thumbsDownLabel, onClick: onThumbsDown, className: "".concat(baseClass, "__button ").concat(thumbsDownActiveClass).trim() })));
};
exports.OracleThumbs = OracleThumbs;
